import { useEffect, type FC } from "react";

/**
 * Performs a full-page redirect to a URL outside the SPA router.
 * Use this instead of React Router's `<Navigate>` when the target
 * is a backend endpoint or external URL that must not be handled
 * by client-side routing.
 */
export const ExternalRedirect: FC<{ to: string }> = ({ to }) => {
    useEffect(() => {
        window.location.href = to;
    }, [to]);

    return null;
};
